import { render, staticRenderFns } from "./TicketLineHead.vue?vue&type=template&id=6b8e18a4&scoped=true&"
import script from "./TicketLineHead.vue?vue&type=script&lang=js&"
export * from "./TicketLineHead.vue?vue&type=script&lang=js&"
import style0 from "./TicketLineHead.vue?vue&type=style&index=0&id=6b8e18a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8e18a4",
  null
  
)

export default component.exports